import { message } from "antd";
import { ICandidate, ISearchCandidate } from "../interfaces/candidatesListFace";

const getCandidateDisplayName = (candidate?: ICandidate | ISearchCandidate) => {
  if (!candidate) return '';
  if (candidate?.firstName || candidate?.lastName) {
    return `${candidate?.firstName ?? ''} ${candidate?.lastName ?? ''}`.trim();
  }
  if (candidate?.cvFileName) {
    return candidate?.cvFileName;
  }
  return '';
};

export function relocateNotification({candidate, destination, isStage = false, onClick}: {candidate?: ICandidate | ISearchCandidate; destination?: string; isStage?: boolean; onClick?: () => void}) {    
  const candidateName = getCandidateDisplayName(candidate);

  message.open({
    type: 'success',
    duration: 6,
    content: (
    <div className='flex gap-4'>
      <div>
        <span className='font-bold'>{candidateName} </span>
        moved to
        <span className='font-bold'> {destination ? destination?.charAt(0).toUpperCase() + destination?.slice(1) : ''} {isStage ? 'stage' : 'job'}.</span>
      </div>
      <div
        className='underline cursor-pointer'
        onClick={() =>{
          message.destroy();
          onClick?.();
        }}
      >
        Go to candidate.
      </div>
    </div>
    ),
  });
}